module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = 45
// module chunks = 0 1